export default __webpack_public_path__ + "static/media/logo-colorbackground.f3006b28.png";